// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CollapseController from "./collapse_controller.js"
application.register("collapse", CollapseController)

import HelloController from "./hello_controller.js"
application.register("hello", HelloController)

import CarouselController from "./carousel_controller.js"
application.register("carousel", CarouselController)

import NavController from "./nav_controller.js"
application.register("nav", NavController)

import SearchFormController from "./search_form_controller.js"
application.register("search-form", SearchFormController)

import ToastController from "./toast_controller.js"
application.register("toast", ToastController)

import WowController from "./wow_controller.js"
application.register("wow", WowController)

import MediaPickerController from "./media_picker_controller.js"
application.register("media-picker", MediaPickerController)

import PreviewImageController from "./preview_image_controller.js"
application.register("preview-image", PreviewImageController)
